import axios from 'axios'
import route from '../ziggy/route'

export default {
    getItems() {
        return axios.get(route('shop.api.cart.items.index').url())
    },

    add(id, quantity) {
        return axios.post(route('shop.api.cart.items.store').url(), { id, quantity })
    },

    update(id, quantity) {
        return axios.patch(route('shop.api.cart.items.update').url(), { id, quantity })
    },

    remove(id) {
        return axios.delete(route('shop.api.cart.items.destroy').url(), { data: { id } })
    },

    redeemCoupon(code) {
        return axios.post(route('shop.api.cart.coupons.redeem').url(), { code })
    },
    
    removeCoupon(code) {
        return axios.delete(route('shop.api.cart.coupons.remove').url(), { data: { code } })
    }
}
